export default "__VITE_ASSET__BeK3I9iY__"